import { render, staticRenderFns } from "./lrSelect.vue?vue&type=template&id=47a96a3b&"
import script from "./lrSelect.vue?vue&type=script&lang=js&"
export * from "./lrSelect.vue?vue&type=script&lang=js&"
import style0 from "./lrSelect.vue?vue&type=style&index=0&id=47a96a3b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports